import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CommonDataStore } from './common-data.store';
import { DropdownItem } from '../../models/dropdown-item';

@Injectable()
export class CountryResolver implements Resolve<any> {

    constructor(private commonDataStore: CommonDataStore) { }

    resolve(): Observable<DropdownItem[]> {
        return this.commonDataStore.loadCountries();
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/common-data/country.resolver.ts